import React, { forwardRef, useState } from 'react';
import { readOnlyAction, useAdminAccess } from 'contexts/adminAccess';
import MenuItem from '@material-ui/core/MenuItem';
import SubUserRolesDialog from './SubUserRolesDialog';

const EditSubUserAction = forwardRef((props: any, ref: any) => {
  const { canWrite } = useAdminAccess();
  const { tenantId, record } = props;
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MenuItem ref={ref} onClick={handleOpen}>
        {canWrite ? 'Edit' : 'View'}
      </MenuItem>

      {open && (
        <SubUserRolesDialog
          open={open}
          onClose={handleClose}
          initialValues={record}
          tenantId={tenantId}
        />
      )}
    </>
  );
});

export default readOnlyAction(EditSubUserAction);
